import React from 'react';
import { ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { TrustBadges } from './TrustBadges';
import { checkoutUrl, productImage } from './constants';
export function FinalCTA() {
  return <section className="py-5 px-4 sm:px-6 bg-brand-violet text-white border-t-4 border-brand-gold text-center" data-id="element-38" data-mp="c7k59wyseloc">
      <p className="text-[11px] font-heading font-bold text-brand-gold uppercase tracking-widest mb-1" data-id="element-39" data-mp="83m6xohadewc">
        Une dernière opportunité
      </p>
      <p className="text-[13px] sm:text-base font-medium leading-snug max-w-2xl mx-auto mb-3" data-id="element-40" data-mp="h655vxhyb7db">
        Chaque entraînement est une occasion d&apos;aider vos gymnastes à progresser, à développer leur technique et à
        atteindre leur meilleur niveau. Ne perdez plus des heures à préparer chaque séance. Avec GYM RYTHMIQUE PRO™, vous
        disposez d&apos;un système complet pour organiser vos entraînements, construire des progressions efficaces et
        accompagner vos gymnastes avec davantage de méthode.{' '}
        <span className="font-bold" data-id="element-41" data-mp="2c5g7m9or38xj">
          Offrez-vous enfin l&apos;outil professionnel que vous auriez aimé avoir dès le début de votre carrière.
        </span>
      </p>
      <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="block mb-3" data-id="element-42" data-mp="2m341kxej8cen">
        <img src={productImage} alt="Gym Rythmique Pro — Système Complet 6-en-1 + 5 Bonus Premium" className="w-full max-w-[200px] mx-auto drop-shadow-xl" data-id="element-43" data-mp="2r1xhewhakfhz" />
      </a>
      <div className="bg-white/10 border border-white/30 rounded-lg p-2.5 mb-3 max-w-sm mx-auto" data-id="element-44" data-mp="302c4a09wm2nl">
        <p className="font-heading font-bold text-sm leading-tight" data-id="element-45" data-mp="34tlr6t42irvs">GYM RYTHMIQUE PRO™</p>
        <p className="text-xs font-semibold" data-id="element-46" data-mp="39sf5uov3coxj">Le Système Complet de Planification 6-en-1 + 5 Bonus Premium</p>
        <p className="text-[11px] line-through opacity-70 mt-1.5" data-id="element-47" data-mp="3errrj6a87pyj">Prix habituel : 97 €</p>
        <p className="font-display text-4xl tracking-wide text-brand-gold leading-none" data-id="element-48" data-mp="3it39cpmuz6w6">
          Aujourd&apos;hui seulement : 27 €
        </p>
      </div>
      <div className="max-w-md mx-auto mb-2" data-id="element-49" data-mp="1jov3802feogl">
        <CTAButton href={checkoutUrl} className="!bg-brand-gold !text-brand-violet !border-brand-goldDark hover:!bg-[#E7B53C] shadow-[0_5px_14px_rgba(216,161,31,0.45)]" data-id="element-50" data-mp="1ep8mvhraws3k">
          🚀 OUI ! JE VEUX GYM RYTHMIQUE PRO™
        </CTAButton>
      </div>
      <p className="text-[11px] font-bold mb-1.5 flex items-center justify-center gap-1" data-id="element-51" data-mp="1nnu6lg8ied5x">
        <ZapIcon className="w-3.5 h-3.5 text-brand-gold" data-id="element-52" data-mp="22d048zrp7vbp" /> Accès immédiat • Livraison instantanée par e-mail
      </p>
      <TrustBadges variant="dark" data-id="element-53" data-mp="1xi46rk3p0fr7" />
    </section>;
}